import { Directive, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  NumberEleven,
  NumberTen,
  NumberSix,
  NumberTwo
} from '../../shared/utils/constants/global.constants';

@Directive({
  selector: '[formControlName][appPhoneMask]',
  standalone: false
})
export class PhoneMaskDirective implements OnInit, OnDestroy {
  valueSubscription: Subscription;
  @Input() isMobile: boolean = false;

  constructor(public ngControl: NgControl) {
  }

  ngOnInit() {
    this.valueSubscription = this.ngControl.control.valueChanges.subscribe(
      (value) => {
        const newVal = this.onInputChange(value);
        this.ngControl.control.patchValue(newVal, { emitEvent: false });
      }
    );
  }

  @HostListener('input', ['$event'])
  onInputChange(event) {
    if (event === null) {
      return null;
    }
    const prefix = '+55 ';

    let newVal = event.replace(/\D/g, '');
    if (newVal.length > 1) {
      newVal = newVal.substring(2);
    }

    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= NumberTwo) {
      newVal = newVal.replace(/^(\d{0,2})/, '($1)');
    } else if (newVal.length <= NumberSix) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
    } else if (newVal.length <= NumberTen && !this.isMobile) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, '($1) $2-$3');
    } else if (newVal.length <= NumberEleven && this.isMobile) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,5})(\d{0,4})/, '($1) $2-$3');
    }

    if (newVal === '') {
      newVal = '';
    }
    return prefix + newVal;
  }

  ngOnDestroy(): void {
    this.valueSubscription.unsubscribe();
  }
}
